export const PROCESSING = "PROCESSING";
export const ERROR = "ERROR";
export const LOADING = "LOADING";
